import reframe, { parametric, pathSubscription, regSub, subscription } from 'nike-re-framejs';
import { Set } from 'immutable';

import { userFavouritePath } from './handlers';

regSub('favourite.ids.menuItems', db => db.getIn([...userFavouritePath, 'menuItems'], Set()));

export const casinoFavorites$ = pathSubscription([...userFavouritePath, 'casinoVegasGames'], []);

regSub(
    'favourite.ids.menuItems.isFavorite',
    () => [reframe.subscribe(['favourite.ids.menuItems'])],
    ([menuItems], [_, boxId]) => menuItems.has(boxId)
);

export const isFavoriteCasinoGame$$ = parametric(gameId =>
    subscription(favoriteCasinoGames => favoriteCasinoGames.includes(gameId), casinoFavorites$)
);
